<div class="headline">
  <span class="mat-h1 m0">Suchergebnisse für "{{ query }}"</span>
</div>
<hr class="divider">

<div class="search-results-wrapper">
  @if (isLoading) {
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
  } @else if (groups.length === 0) {
    <p>Keine Ergebnisse gefunden.</p>
  } @else {
    @for (group of groups; track group.type) {
      <div class="search-result-group">
        <h3>{{ typeLabels[group.type].label }} ({{ group.totalMatches }})</h3>
        <mat-grid-list [cols]="cols" rowHeight="72px" gutterSize="8px">
          @for (result of group.results; track result.id) {
            <mat-grid-tile (click)="openResult(group.type, result.id)">
              <app-search-result-item [result]="result"></app-search-result-item>
            </mat-grid-tile>
          }
        </mat-grid-list>
        @if (group.totalMatches > group.results.length) {
          <button (click)="showAllInGroup(group)" color="primary" mat-button>
            @if (isCategoryType(group.type)) {
              alle {{ group.totalMatches }} anzeigen
            } @else {
              alle {{ group.totalMatches }} Ergebnisse in {{ typeLabels[group.type].label }} anzeigen
            }
          </button>
        }
      </div>
    }
  }
</div>
